export interface IDashboard {
	users: IDashboardUsers
	deposits: ICurrenciesValue
	withdrawals: ICurrenciesValue
	tradeFees: ICurrenciesValue
	withdrawFees: ICurrenciesValue
}
export interface IDashboardUsers {
	unverified: number
	pending: number
	verified: number
	blocked: number
	admin: number
	operator: number
}
export interface ICurrenciesValue {
	[currency: string]: number
}
export class DashboardUsers implements IDashboardUsers {
	unverified: number = 0
	pending: number = 0
	verified: number = 0
	blocked: number = 0
	admin: number = 0
	operator: number = 0
}
export class Dashboard implements IDashboard {
	users: IDashboardUsers = new DashboardUsers()
	deposits: ICurrenciesValue = {}
	withdrawals: ICurrenciesValue = {}
	tradeFees: ICurrenciesValue = {}
	withdrawFees: ICurrenciesValue = {}
}


// WEBPACK FOOTER //
// ./src/models/dashboard.ts